module.exports = __webpack_public_path__ + "img/thumbnail_default.562197e4.svg";